module.exports = __webpack_public_path__ + "img/warning.7d200e8d.svg";